function clean(value?: string | null): string {
  return (value || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

// CNPJ para exibição (00.000.000/0000-00); aceita o CNPJ alfanumérico. Outros tamanhos voltam como vieram.
export function formatCnpj(value?: string | null): string {
  const digits = clean(value);

  if (digits.length !== 14) return value || '';

  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

// CPF para exibição (000.000.000-00). Outros tamanhos voltam como vieram.
export function formatCpf(value?: string | null): string {
  const digits = clean(value);

  if (digits.length !== 11) return value || '';

  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

// "CPF 000.000.000-00" ou "CNPJ 00.000.000/0000-00", conforme o tipo de pessoa (N = física, L = jurídica).
export function documentLabel(personType: string, value?: string | null): string {
  if (!value) return '';

  return personType === 'N' ? `CPF ${formatCpf(value)}` : `CNPJ ${formatCnpj(value)}`;
}
